import React from 'react';
import Card from '../../../common/components/Card/Card';
import ContractSelector from '../ContractSelector/ContractSelector';
import './ContractCard.scss';

const ContractCard = ({
    selectedContract,
    setSelectedContract,
    contracts,
    addableContracts,
    getContractOs,
    privateKey,
    publicKey,
    patient,
    selectorOpen,
    setSelectorOpen,
}) => {
    const handleSelect = (newContracts) => {
        const latest = newContracts[newContracts.length - 1];
        setSelectedContract(latest);
        setSelectorOpen(false);
    };

    return (
        <Card title='Datos del contrato'>
            {selectedContract ? (
                <>
                    <br />
                    <p>
                        <strong>Descripción:</strong> {selectedContract.descripcion}
                    </p>
                    <p>
                        <strong>Tipo:</strong> {selectedContract.descripcion_tipo}
                    </p>
                </>
            ) : (
                <p>No hay contrato seleccionado.</p>
            )}

            <br />
            <ContractSelector
                contracts={[]}
                setContracts={handleSelect}
                addableContracts={addableContracts}
                getContractOs={getContractOs}
                privateKey={privateKey}
                publicKey={publicKey}
                patient={patient}
                show={selectorOpen}
                setShow={setSelectorOpen}
            >
                + Seleccionar contrato
            </ContractSelector>
        </Card>
    );
};

export default ContractCard;
